import React from 'react';
import {SvgIcon} from '@material-ui/core';

const styles = {
  heatPrephase: {
    fill: 'gray',
  },
  steamColored: {
    fill: '#2cc8ff',
  },
  steamGray: {
    fill: 'gray',
  },
  overrideSizeColored: {
    fontSize: 35 + 'px',
  },
  overrideSize: {
    fontSize: 30 + 'px',
  },
};

export const Heat = ({isColored, style}) => (
  <SvgIcon
    viewBox="-7 0 30 32"
    style={{
      ...(isColored ? styles.overrideSizeColored : styles.overrideSize),
      ...style,
    }}
    nativeColor={isColored ? 'red' : 'gray'}>
    <path d="M6.66,31.71A6.65,6.65,0,0,1,2.5,19.86V4.17a4.17,4.17,0,1,1,8.33,0V19.86A6.65,6.65,0,0,1,6.66,31.71Zm0-30.2A2.67,2.67,0,0,0,4,4.17V20.62l-.31.23a5.16,5.16,0,1,0,6,0l-.32-.22V4.17A2.66,2.66,0,0,0,6.66,1.51Z" />
    <path d="M7.45,12.46V22.3a2.79,2.79,0,1,1-1.57,0V12.46Z" />
  </SvgIcon>
);

export const Steam = ({isColored, style}) => (
  <SvgIcon
    viewBox="0 -3 25 30"
    style={{
      ...(isColored ? styles.overrideSizeColored : styles.overrideSize),
      ...style,
    }}
    nativeColor={isColored ? '#2cc8ff' : 'gray'}>
    <polygon
      className={isColored ? styles.steamColored : styles.steamGray}
      points="17.75 11.3 15.98 0.24 17.47 0 19.24 11.06 17.75 11.3 17.75 11.3"
    />
    <polygon
      className={isColored ? styles.steamColored : styles.steamGray}
      points="7.95 11.3 6.46 11.06 8.23 0 9.71 0.24 7.95 11.3 7.95 11.3"
    />
    <polygon
      className={isColored ? styles.steamColored : styles.steamGray}
      points="13.55 14.99 12.05 14.99 12.05 4.88 13.55 4.88 13.55 14.99 13.55 14.99"
    />
    <path d="M12.86,23.48a7.08,7.08,0,0,1-6.59-4.55A5.85,5.85,0,0,1,1.18,16.8a5.4,5.4,0,0,1,1-7.7l1.36,1.81A3.14,3.14,0,0,0,3,15.49a3.81,3.81,0,0,0,3.8,1.09l1.06-.22.26,1.05c0,.16,1,3.81,4.66,3.81s4.67-3.65,4.71-3.81l.26-1.05,1.07.22a3.83,3.83,0,0,0,3.82-1.11,3.14,3.14,0,0,0-.57-4.56L23.45,9.1a5.39,5.39,0,0,1,1,7.69,5.86,5.86,0,0,1-5.11,2.14,7,7,0,0,1-6.52,4.55Z" />
  </SvgIcon>
);

export const Damper = ({isColored, style}) => (
  <SvgIcon
    viewBox="0 -3 23 28"
    style={{
      ...(isColored ? styles.overrideSizeColored : styles.overrideSize),
      ...style,
    }}
    nativeColor={isColored ? '#f19300' : 'gray'}>
    <path d="M14.1,3.13l1.42-1.46a6,6,0,0,0-8.26,0L6.14.55,5,5.13,9.54,3.87l-.83-.8A3.9,3.9,0,0,1,14.1,3.13Z" />
    <path d="M7.16,18.07,5.75,19.52a6,6,0,0,0,8.26,0l1.12,1.1,1.15-4.58-4.55,1.26.83.81A3.94,3.94,0,0,1,7.16,18.07Z" />
    <path d="M22.07,11.74l0-2.29-7.2.09a4,4,0,0,0-7.65.09L0,9.73,0,12l7.19-.09a4,4,0,0,0,6.69,1.61,4,4,0,0,0,1-1.71Zm-12.6.55a2.21,2.21,0,1,1,3.13,0A2.21,2.21,0,0,1,9.47,12.29Z" />
  </SvgIcon>
);

export const Ventilation = ({isColored, style}) => (
  <SvgIcon
    viewBox="2 -1 22 28"
    style={{
      ...(isColored ? styles.overrideSizeColored : styles.overrideSize),
      ...style,
    }}
    nativeColor={isColored ? '#96bd0d' : 'gray'}>
    <path d="M10.26,26.73a6.68,6.68,0,0,1-1.53-.19L6.9,25.9a5.79,5.79,0,0,1-3.12-3.21,3.68,3.68,0,0,1,.41-2.91,4.7,4.7,0,0,1,2.74-1.89,6.21,6.21,0,0,0,1.51-.69,4.09,4.09,0,0,0,1.08-1c0-.1-.24-.46-.36-.62L9,15.31a13.05,13.05,0,0,1-2.91.39,7.58,7.58,0,0,1-1.8-.2C1.11,14.74-.51,12.11.14,8.8l0-.1L.8,6.89C2,4.6,3.83,3.37,5.58,3.71c2.21.42,2.77,1.92,3.23,3.12a8.41,8.41,0,0,0,.37.9c.71,1.39,1.18,1.68,1.37,1.74a5.88,5.88,0,0,0,.9-.48l-.06-.17c-.06-.18-.12-.35-.15-.48a9.14,9.14,0,0,1,0-4.13A5.1,5.1,0,0,1,16.49,0a7.6,7.6,0,0,1,1.4.13l.12,0L19.84.8c1.17.66,4.25,2.41,2.92,5.66a4.32,4.32,0,0,1-2.88,2.33,9.78,9.78,0,0,0-1,.43c-1,.56-1.58,1-1.64,1.38a2,2,0,0,0,.33.55l.18.23a12.58,12.58,0,0,1,2.94-.4,7.55,7.55,0,0,1,2.66.46c2.62,1,3.83,3.4,3.23,6.5l0,.1-.64,1.81c-1,1.63-2.12,3.22-4.06,3.22a4,4,0,0,1-1.06-.15A4.09,4.09,0,0,1,18,20c-.08-.2-.15-.39-.24-.58a6.17,6.17,0,0,0-1-1.71,2.4,2.4,0,0,0-.52-.46,6.07,6.07,0,0,0-1,.45l.06.18a4.3,4.3,0,0,1,.18.58,8.57,8.57,0,0,1-.71,5.85,5.14,5.14,0,0,1-4.55,2.45ZM7.55,24.54l1.61.56a5.29,5.29,0,0,0,1.1.12,3.64,3.64,0,0,0,3.25-1.7A7.08,7.08,0,0,0,14,18.75a2,2,0,0,0-.12-.4,1.77,1.77,0,0,1-.11-1.3c.27-.65,2-1.36,2.49-1.36l.21,0a2.87,2.87,0,0,1,1.33.92,7.54,7.54,0,0,1,1.29,2.14c.09.2.17.42.26.63.43,1.1.75,1.78,1.78,2.06,1.45.39,2.24-.44,3.39-2.33l.53-1.54c.26-1.38.29-3.79-2.29-4.75a6.15,6.15,0,0,0-2.13-.36,12.14,12.14,0,0,0-3.14.5l-.73.19-.19-.74a1.84,1.84,0,0,0-.26-.38,2.24,2.24,0,0,1-.62-1.69c.21-1.28,1.7-2.09,2.42-2.47a9.47,9.47,0,0,1,1.2-.52c1-.38,1.67-.66,2-1.49.59-1.43-.05-2.51-2.2-3.75L17.57,1.6a6.74,6.74,0,0,0-1.08-.09,3.62,3.62,0,0,0-3.8,3.07A7.59,7.59,0,0,0,12.7,8l.11.31A1.89,1.89,0,0,1,13,9.48c-.22.72-2,1.51-2.45,1.51H10.4c-1.22-.17-2.05-1.55-2.56-2.57a8.65,8.65,0,0,1-.44-1C7,6.25,6.68,5.45,5.3,5.19S2.83,6.27,2.16,7.53L1.61,9.14c-.48,2.5.65,4.33,3,4.89a6.19,6.19,0,0,0,1.45.17,13,13,0,0,0,3.12-.5l.73-.18.18.74a2.87,2.87,0,0,0,.26.4,2.23,2.23,0,0,1,.6,1.92A4.61,4.61,0,0,1,9.3,18.44a8.31,8.31,0,0,1-1.84.86,3.54,3.54,0,0,0-2,1.21,2.25,2.25,0,0,0-.27,1.75,4.53,4.53,0,0,0,2.32,2.28Z" />
    <path
      style={{fillRule: 'evenodd'}}
      d="M15.77,13.37A2.42,2.42,0,1,1,13.35,11,2.41,2.41,0,0,1,15.77,13.37Z"
    />
  </SvgIcon>
);

export const Duration = ({isBlack, style}) => (
  <SvgIcon
    viewBox="1 -2 30 36"
    style={{
      ...(isBlack ? styles.overrideSizeColored : styles.overrideSize),
      ...style,
    }}
    nativeColor={isBlack ? 'black' : 'gray'}>
    <path d="M16.23,0A16.24,16.24,0,1,0,32.48,16.24,16.23,16.23,0,0,0,16.23,0Zm0,29.23a13,13,0,1,1,13-13A13,13,0,0,1,16.24,29.23Z" />
    <path d="M17.05,8.12H14.61v9.74L23.13,23l1.23-2-7.31-4.34Z" />
  </SvgIcon>
);

export const Start = ({isBlack, style}) => (
  <SvgIcon
    viewBox="0 0 511.61 512"
    style={{
      ...(isBlack ? styles.overrideSizeColored : styles.overrideSize),
      ...style,
    }}
    nativeColor={isBlack ? 'black' : 'gray'}>
    <path
      strokeWidth="0"
      d="M275.63 275.63c0 22.03-17.92 39.95-39.95 39.95s-39.95-17.92-39.95-39.95c0-14.75 8.05-27.65 19.97-34.57V130.83h39.95v110.23c11.93 6.92 19.97 19.82 19.97 34.57zm235.98 110.85L306.59 512.01V260.96l205.02 125.53zm-165.08 54.23l88.58-54.23-88.58-54.23v108.46zM39.95 275.63c0-107.93 87.81-195.73 195.73-195.73s195.73 87.81 195.73 195.73c0 4.9-.19 9.77-.54 14.58l37.52 22.97c1.96-12.3 2.97-24.85 2.97-37.55 0-62.95-24.51-122.14-69.03-166.65a214.48 214.48 0 00-5.09-4.92l16.55-19.84 27.12 22.61 25.58-30.68-84.91-70.82L356 36.01l27.12 22.61-17.13 20.54c-32.84-21.88-70.57-35.06-110.33-38.37V0h-39.95v40.79C160.29 45.41 108.8 69.2 69.03 108.97 24.51 153.49 0 212.67 0 275.63s24.51 122.14 69.03 166.65c44.51 44.51 103.7 69.03 166.65 69.03 10.44 0 20.77-.69 30.96-2.02V468.9a196.373 196.373 0 01-30.96 2.46c-107.93 0-195.73-87.81-195.73-195.73z"></path>
  </SvgIcon>
);

export const Prephase = () => (
  <SvgIcon viewBox="5 -3 20 23" style={styles.overrideSize} nativeColor="gray">
    <polygon
      className={styles.heatPrephase}
      points="0 7.01 12.84 7.01 12.84 4.08 17.27 8.51 12.84 12.94 12.84 9.92 0 9.92 0 7.01"
    />
    <path d="M21.8,16.71H9.28A4.57,4.57,0,0,1,4.89,12H6.82a2.64,2.64,0,0,0,2.46,2.8H21.8A2.64,2.64,0,0,0,24.26,12V4.72A2.64,2.64,0,0,0,21.8,1.93H9.28A2.64,2.64,0,0,0,6.82,4.72H4.89A4.57,4.57,0,0,1,9.28,0H21.8a4.57,4.57,0,0,1,4.39,4.72V12A4.57,4.57,0,0,1,21.8,16.71Z" />
  </SvgIcon>
);
